import React, { useMemo } from 'react';

const COLORS = [
  { bg: 'rgba(16, 185, 129, 0.08)', border: '#10b981', text: '#059669' }, // green (sin resp)
  { bg: 'rgba(245, 158, 11, 0.08)', border: '#f59e0b', text: '#d97706' }, // amber (concurrente)
  { bg: 'rgba(239, 68, 68, 0.08)', border: '#ef4444', text: '#dc2626' }, // red (con resp)
  { bg: 'rgba(59, 130, 246, 0.08)', border: '#3b82f6', text: '#2563eb' }, // blue (propio)
  { bg: 'rgba(148, 163, 184, 0.08)', border: '#94a3b8', text: '#64748b' }, // slate (otro)
];

const getResponsabilidadLabel = (cat) => {
  if (cat === undefined || cat === null) return 'SIN ESPECIFICAR';
  const catStr = cat.toString().trim();
  if (catStr.startsWith('4')) return 'Sin Responsabilidad (4xx)';
  if (catStr.startsWith('5')) return 'Resp. Concurrente (5xx)';
  if (catStr.startsWith('6')) return 'Con Responsabilidad (6xx)';
  if (catStr.startsWith('7')) return 'Hecho Propio / Sin 3ro (7xx)';
  return `Código ${catStr}`;
};

export default function EstadisticasResponsabilidad({ stros, activeResponsabilidad, onSelectResponsabilidad }) {
  const aggregated = useMemo(() => {
    if (!stros) return [];

    const counts = {};
    stros.forEach(s => {
      // Grouping by label
      const label = getResponsabilidadLabel(s.catStro);
      counts[label] = (counts[label] || 0) + 1;
    });

    return Object.entries(counts)
      .map(([label, count]) => ({
        label,
        count,
      }))
      .sort((a, b) => b.count - a.count);
  }, [stros]);

  if (!stros || stros.length === 0) {
    return (
      <div className="est-card">
        <div className="est-card-header">
          <span className="est-card-title">
            <i className="bi bi-shield-shaded"></i>
            Distribución por Responsabilidad
          </span>
        </div>
        <div className="est-empty">
          <i className="bi bi-inbox"></i>
          <p>No hay datos de siniestros</p>
        </div>
      </div>
    );
  }

  return (
    <div className="est-card">
      <div className="est-card-header">
        <span className="est-card-title">
          <i className="bi bi-shield-shaded"></i>
          Distribución por Responsabilidad
        </span>
        <span className="est-card-badge">
          {aggregated.length} categorías
        </span>
      </div>

      <div className="est-chips-grid">
        {/* "Todos" chip */}
        <button
          className={`est-chip ${activeResponsabilidad === null ? 'active' : ''}`}
          onClick={() => onSelectResponsabilidad(null)}
          style={{
            '--chip-color': '#0f172a',
            '--chip-border': activeResponsabilidad === null ? '#42C3BA' : '#e2e8f0',
            '--chip-bg': activeResponsabilidad === null ? 'rgba(66, 195, 186, 0.08)' : 'white',
          }}
        >
          <span className="est-chip-label">Todos</span>
          <span className="est-chip-count">{stros.length}</span>
        </button>

        {aggregated.map((item, idx) => {
          const color = COLORS[idx % COLORS.length];
          const isActive = activeResponsabilidad === item.label;

          return (
            <button
              key={item.label}
              className={`est-chip ${isActive ? 'active' : ''}`}
              onClick={() => onSelectResponsabilidad(isActive ? null : item.label)}
              style={{
                '--chip-color': color.text,
                '--chip-border': isActive ? color.border : '#e2e8f0',
                '--chip-bg': isActive ? color.bg : 'white',
              }}
              title={item.label}
            >
              <span className="est-chip-label">{item.label}</span>
              <span className="est-chip-count">{item.count}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

// Export the label helper so it can be used for filtering in the main page
export { getResponsabilidadLabel };
